import React, { Component } from 'react';
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import GoogleMap from 'google-map-react';

import './style/contact.scss';


const mapStyles = {
    width: '100%',
    height: '100%'
}

const markerStyle = {
    height: '30px',
    width: '80px',
    marginTop: '-50px'
}

const imgStyle = {
    height: '100%'
}

const titleStyle = {
    fontSize: '14px',
    fontFamily: 'KanitRegular'
}


class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            latDefault: 13.8555107,
            lngDefault: 100.5852318,
        };
    }


    render() {

        const Marker = ({ title }) => (
            <div style={markerStyle}>
                <img style={imgStyle} src="/img/icon/location.png" alt={title} />
                {/* <h3 style={titleStyle}>{title}</h3> */}
            </div>
        );


        return (
            <div className="cover-login">
                <div className="wh-bg">
                    <div className="container">
                        <Navbar />
                    </div>
                </div>

                
                <div className="box-contact container">
                    <div className="social">
                        <p className="chanel">ติดต่อเราผ่านช่องทางต่างๆได้ดังนี้</p>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="bx-chanel">
                                    <div className="img-chanel">
                                        <img alt="" src="/img/social/email.png" />
                                    </div>
                                    <p className="type-chanel">EMAIL</p>
                                    <p className="data">nippymarketplace@email.com</p>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="bx-chanel">
                                    <div className="img-chanel">
                                        <img alt="" src="/img/social/phone.png" />
                                    </div>
                                    <p className="type-chanel">PHONE CALL</p>
                                    <p className="data">02-558-6888</p>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="bx-chanel">
                                    <div className="img-chanel">
                                        <img alt="" src="/img/social/line.png" />
                                    </div>
                                    <p className="type-chanel">LINE</p>
                                    <p className="data">@nippymarketplace</p>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="bx-chanel">
                                    <div className="img-chanel">
                                        <img alt="" src="/img/social/facebook.png" />
                                    </div>
                                    <p className="type-chanel">FACEBOOK</p>
                                    <p className="data">Nippy Marketplace</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="social map">
                        <p className="chanel">ที่อยู่</p>
                        <p className="address">2410 2 ถนนพหลโยธิน แขวง เสนานิคม เขตจตุจักร กรุงเทพมหานคร 10900</p>

                        <div className="bx-map">
                        <GoogleMap


                            style={mapStyles}
                            bootstrapURLKeys={{ key: 'AIzaSyC8bJru_qVoe0XgT1xmBD7rygLVUxq7FwY' }}
                            center={{
                                lat: this.state.latDefault,
                                lng: this.state.lngDefault
                            }}
                            zoom={17}
                            // onClick={(e) => { this.changeMarker(e) }}
                        >

                            <Marker
                                title={'current location'}
                                lat={this.state.latDefault}
                                lng={this.state.lngDefault}

                            >
                            </Marker>
                        </GoogleMap>
                    </div>
                    </div>
                    {/* <div className="bg-contact">
                        <img className="img-fluid" alt src="/img/banner/banner2.png" />

                        <div className="bx-des">
                            <p className="hd">ติดต่อเรา</p>
                            <p className="des-hd">แจ้งปัญหาหรือต้องการสอบถามข้อมูลต่างๆ ได้ทาง</p>
                            <div className="grid-con">
                                <img className="img-fluid" alt src="/img/icon/phone-call.png" />
                                <p className="decon">063-XXX-XXXX</p>
                            </div>
                            <div className="grid-con">
                                <img className="img-fluid" alt src="/img/icon/email.png" />
                                <p className="decon">nippymarketplace@email.com</p>
                            </div>
                        </div>
                    </div> */}
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Contact;
